export const labelResponse = (): string => {
    return "Respuesta";
  };